import { Box3, Intersection, Points, Ray, Raycaster, Scene, Vector3 } from 'three';

import { ProgressController } from '../../../react/utils/progress-controller';
import { PromiseAbortSignal } from '../../../react/utils/promise-abort-controller';
import { SkyviewCamera } from '../../cameras/types';
import { Pickable } from '../../pickable/pickable';
import { pickNearCursor } from '../../utilities/pick-near-cursor';

export type PointSizeInterpolationType = 'Dynamic' | 'Fixed';
export interface PointSizeInterpolationSettings {
  pointSizeInterpolationType: PointSizeInterpolationType;
  size: number;
}

export abstract class PointCloud extends Scene implements Pickable {
  abstract getMaxLodChunksFromRays(
    points: Ray[],
    signal?: PromiseAbortSignal,
    onProgress?: ProgressController,
  ): Promise<Points[]>;
  abstract getMaxLodChunksWithinBoundingBox(
    bbox: Box3,
    signal?: PromiseAbortSignal,
    onProgress?: ProgressController,
  ): Promise<Points[]>;
  abstract loadLodChunks(camera: SkyviewCamera): Promise<void>;
  abstract cullLodChunks(camera: SkyviewCamera): void;

  abstract pick(ray: Raycaster): Intersection[];
  abstract available(): boolean;

  /** Every point near a ray from the camera, at the points' own positions. */
  abstract intersect(rayCaster: Raycaster): Intersection[];

  /** Picks the front-most point near the cursor, see pickNearCursor. */
  pickNearCursor(camera: SkyviewCamera, rayCaster: Raycaster): Intersection | undefined {
    return pickNearCursor(camera, rayCaster, this.intersect(rayCaster));
  }

  abstract getBoundingBox(): Box3;
  abstract getOrigo(): Vector3;

  abstract clearCustom(): void;
}
